import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as classNames from 'classnames';
import { IAppOnlyStore } from '../../../stores';
import { PortalSearchInitial, PortalSearchTable } from '.';
import { LoadingSpinner } from './../../../components/indicator';
import { Pagination } from '../../../components/pagination/index';
import { CSSTransitionGroup } from 'react-transition-group';
import * as zenscroll from 'zenscroll';

// Styles
const s = require('./PortalSearch.css');

// Component
@inject('store')
@observer
export class PortalSearch extends React.Component<IAppOnlyStore, {}> {
    public render() {
        const { search, user } = this.props.store;

        return (
            <div className={s.portalSearch}>

                {(search.searchInputEntered && search.searchItemsLength > 0) && (
                    <div className={s.results}>
                        <div className={s.header}>
                            <p>
                                <strong>Search result</strong>
                                <span>{` (${search.searchItemsLength} item${search.searchItemsLength > 1 ? 's' : ''})`}</span>
                                <em>{
                                    'DISCLAIMER: Product images are for illustrative and representation purposes only. ' +
                                    'Item may differ from the actual product.'
                                }</em>
                            </p>
                            <button className={s.clearItem} onClick={search.clearSearchInput}>Clear search query</button>
                        </div>

                        {search.searchItemsGroupedByCar.map((model) => (
                            <PortalSearchTable
                                key={model.concat}
                                cart={model}
                                userPermissionId={user.permissionId}
                                inventoryOnRight={user.isCustomer && user.customerIsPAC}
                            />
                        ))}

                        <Pagination
                            className={s.resultsPagination}
                            entriesName="parts"
                            currentPage={search.searchItemsPage}
                            countPerPage={search.searchFetchLimit}
                            countTotal={search.searchItemsTotalCount}
                            onPageChange={this.handleSearchPageChange}
                        />
                    </div>
                ) || (search.searchInputEntered && !search.searchLoading) && (
                    <div className={s.noResults}>
                        <p>No items have been found...</p>
                    </div>
                )}

                <div className={classNames(s.loading, { [s.visible]: search.searchLoading })}>
                    <LoadingSpinner active={search.searchLoading} />
                </div>

                <CSSTransitionGroup
                    component="div"
                    transitionName="initial-transition"
                    transitionEnter={true}
                    transitionLeave={true}
                    transitionEnterTimeout={600}
                    transitionLeaveTimeout={600}
                >
                    {(!search.searchInputEntered && !search.searchLoading) && (
                        <PortalSearchInitial key="initial" userPermissionId={user.permissionId} />
                    )}
                </CSSTransitionGroup>

            </div>
        );
    }

    private handleSearchPageChange = (newPage: number) => {
        zenscroll.toY(0);
        this.props.store.search.changeItemsPage(newPage);
    }
}

export default PortalSearch;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalSearch/PortalSearch.tsx